/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_HeadingInputs */

const en_tts_tool_heading = /** @type {(inputs: Tts_Tool_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Speech Converter`)
};

const es_tts_tool_heading = /** @type {(inputs: Tts_Tool_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de texto a voz`)
};

/**
* | output |
* | --- |
* | "Text to Speech Converter" |
*
* @param {Tts_Tool_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_heading = /** @type {((inputs?: Tts_Tool_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_heading(inputs)
	return en_tts_tool_heading(inputs)
});